<template>
  <div class="my-ticket-romancecar mb-foot-2button">
    <!-- ヘッダー -->
    <!-- 01:予約, 03:予約取り消し -->
    <MFITTHeader
      v-if="
        myLimitedExpressTicket.ticketing_status == '01' ||
        myLimitedExpressTicket.ticketing_status == '03'
      "
      header-title="予約内容"
      :click-back-button-event="backToMfittIndexPage"
    />
    <!-- 02:購入, 04:払い戻し(購入後CXL) -->
    <MFITTHeader
      v-else-if="
        myLimitedExpressTicket.ticketing_status == '02' ||
        myLimitedExpressTicket.ticketing_status == '04'
      "
      header-title="チケット内容"
      :click-back-button-event="backToMfittIndexPage"
    />

    <hr />

    <!-- 予約/購入情報-->
    <div class="content-block">
      <div class="block">
        <!-- 乗車日 -->
        <ViBoardingDate :boarding-date="myLimitedExpressTicket.boarding_date" />

        <!-- 列車名 -->
        <ViTrainInfo
          :name="myLimitedExpressTicket.train.name"
          :cars-formation-name="
            myLimitedExpressTicket.train.cars_formation.name
          "
        />

        <!-- 区間 -->
        <ViStationSection
          :from="myLimitedExpressTicket.from_station.name"
          :to="myLimitedExpressTicket.to_station.name"
        />

        <!-- 時間 -->
        <ViDepartureAndArrival
          :departure="myLimitedExpressTicket.departure_at"
          :arrival="myLimitedExpressTicket.arrival_at"
        />

        <!-- 座席種類 -->
        <StoreSeatType
          :selected-seats="myLimitedExpressTicket.seats"
          :selected-exclusive-cars="
            myLimitedExpressTicket.train.cars_formation.cars
          "
        />
        <!-- 座席 -->
        <StoreSeats
          :seats="myLimitedExpressTicket.seats"
          :is-purchased="
            myLimitedExpressTicket.ticketing_status == '02' ||
            myLimitedExpressTicket.ticketing_status == '04'
          "
        />

        <!-- 確認番号(購入後) -->
        <StoreConfirmationNumber
          v-if="myLimitedExpressTicket.ticketing_status == '02'"
          :num="myLimitedExpressTicket.auth_code"
        />
      </div>
    </div>

    <div class="caution-block">
      <!-- 購入期限の注意書き -->
      <StorePurchaseLimitCaution
        v-if="myLimitedExpressTicket.ticketing_status == '01'"
        :limit="displayMfittDateTime(myLimitedExpressTicket.auto_canceled_at)"
      />
    </div>

    <!-- アクションボタン 発車時刻を過ぎている場合は非表示 -->
    <MFITTMyTicketActions
      v-if="!isOverDepartureAt"
      :my-limited-express-ticket="myLimitedExpressTicket"
    />
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

import mfittService from "@/services/MFITT";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "TemplateMfittMyTicket",
  setup() {
    const store = useStore();
    const myLimitedExpressTicket = computed(
      () => store.getters["MFITT/myLimitedExpressTicket"]
    );
    const isOverDepartureAt = computed(() =>
      mfittService.isOverDepartureAt(
        myLimitedExpressTicket.value.boarding_date,
        myLimitedExpressTicket.value.departure_at
      )
    );

    // headerのbackButton用の処理。
    const backToMfittIndexPage = () => {
      nativeHandlerService.returnNativeAppMfittIndexPage();
    };

    return {
      myLimitedExpressTicket,
      isOverDepartureAt,
      backToMfittIndexPage,
    };
  },
};
</script>

<style>
.my-ticket-romancecar .content-block {
  width: 100%;
  padding: 0 0 16px;
}
.my-ticket-romancecar .content-block .block {
  display: table;
  font-size: 13px;
}
.my-ticket-romancecar .caution-block {
  margin-bottom: 280px !important;
}
</style>
